import isMobile, { isMobileResult } from "ismobilejs";
import jsCookie from "js-cookie";
import platform from "platform";
import { DeviceInfo } from "src/shared/types/device";

export class Platform {
    static PLATFORM_DESKTOP = "desktop";

    static SO_IOS = "ios";

    static SO_ANDROID = "android";

    private static MOBILE_DETECT_SO_IOS = "iOS";

    private static MOBILE_DETECT_SO_ANDROID = "AndroidOS";

    static get info(): isMobileResult {
        return isMobile();
    }

    static isMobile(): boolean {
        const _isMobile = Platform.info.phone;
        const _isTablet = Platform.info.tablet;
        return _isMobile || _isTablet;
    }

    static about(): DeviceInfo {
        const isMobileOrTablet = Platform.isMobile();
        return {
            isMobileOrTablet,
            os: Platform.isAndroid()
                ? Platform.MOBILE_DETECT_SO_ANDROID
                : Platform.MOBILE_DETECT_SO_IOS,
        };
    }

    static isIOS() {
        return Platform.info.apple.device;
    }

    static isIPad(): boolean {
        return Platform.info.apple.tablet;
    }

    static isAndroid() {
        return Platform.info.android.device;
    }

    static getOSVersion(): number {
        if (platform.version) {
            return parseInt(platform.version, 10);
        }
        return 0;
    }

    static isRunningEmbedded(): boolean {
        const origin = jsCookie.get("origin");
        const hasWebOrigin = origin === "flutterWeb";
        const isRunningOnIframe = window.self !== window.top;
        return hasWebOrigin && isRunningOnIframe;
    }

    static isRunningOnFlutter(): boolean {
        const hasFlagInCookie = document.cookie.includes("hide_bottombar");
        const origin = jsCookie.get("origin");

        if (origin === "flutterWeb") {
            return false;
        }

        const hasFlutterUserAgent =
            window.navigator.userAgent.includes("flutter");

        return (
            hasFlagInCookie ||
            origin === "flutterApp" ||
            window.flutterApp === true ||
            hasFlutterUserAgent
        );
    }
}
